import React from "react";

const BranchInfo = (props) => {
  const { BranchName, BranchCode, Address, MobileNo, BranchEmail } =
    props.branch;

  return (
    <>
      <div className="col-lg-4" data-aos="zoom-out-down">
        <div className="branchBox">
          {" "}
          <div className="text-center">
            <i className="fa-solid fa-house-laptop"></i>
          </div>
          <h4>
            Branch Name: <br />
            <span>
              <b>{BranchName}</b>
            </span>
          </h4>
          {/* <h6>
          Branch Code:  <b>{BranchCode}</b>
          </h6> */}
          <h6>
            Mobile No: <br /> <b>{MobileNo}</b>
          </h6>
          <p>
            Email: <br /> <b>{BranchEmail}</b>
          </p>
          <p className="mb-0">
            <b>Address</b>: <br /> {Address}
          </p>
        </div>
      </div>
    </>
  );
};

export default BranchInfo;
